import { EErrorType, type ErrorService } from "draivn-ui-domain";
import { redirectToSessionExpiredPage } from "@/modules/app/utils/session-expired-navigation.util";

export const authErrorDisplayHandlerInit = (errorService: ErrorService) => {
  const authErrorDisplayHandler = () => {
    void redirectToSessionExpiredPage();
  };

  errorService.registerErrorDisplay(EErrorType.AUTHENTICATION, {
    display: authErrorDisplayHandler,
  });
};
